// @ts-nocheck
import { makeStyles } from '@material-ui/core';
export const useStyles = makeStyles((theme) => ({
  orangeRadio: {
    '&.Mui-checked': {
      color: 'orange',
    },
  },
  checkwrap: {
    display: 'flex!important',
    flexDirection: 'row!important',
    gap: '10px',
  },
  checklabel: {
    borderRadius: '4px',
    marginRight: '0!important',
  },
  checked: {
    border: '1px solid rgba(0, 0, 0, 0.23)',
    background: '#EEE',
  },

  radiolabel: {
    width: '100%',
    borderRadius: '4px',
  },
  cautionBox: {
    display: 'flex',
    alignItems: 'center',
    border: '1px solid',
    borderRadius: '4px',
    margin: '5px 0px 0px 0px',
    backgroundColor: '#F44336',
    borderColor: '#F44336',
  },
  radioBox: {
    width: '200px',
    border: '1px solid rgba(0, 0, 0, 0.23)',
    borderRadius: '4px',
    paddingLeft: '10px',
  },
  cautionText: {
    padding: 5,
    fontWeight: 400,
    color: 'white',
  },
  noActionStyle: {
    backgroundColor: '#DBEFDC',
    border: '1px solid',
    borderRadius: '4px',
    borderColor: '#4CAF50',
    paddingLeft: 10,
  },
  nonConditionalSelected: {
    backgroundColor: '#EEE',
    borderColor: '#d1d1d1',
    border: '1px solid',
    borderRadius: '4px',
    paddingLeft: 10,
  },
  actionStyle: {
    backgroundColor: '#FDD9D7',
    border: '1px solid',
    borderRadius: '4px',
    paddingLeft: 10,
    borderColor: '#F44336',
  },
  editorStyles: {
    '& .ql-snow.ql-toolbar button.ql-active .ql-stroke, .ql-snow.ql-toolbar button:focus .ql-stroke, .ql-snow.ql-toolbar button:hover .ql-stroke':
      {
        stroke: '#FBAD33',
      },
  },
}));
